import useSWR from "swr";

type SelectedQuestions = {
  id: string;
  restaurant: string;
  question: string;
  question_content: string;
  order: number;
}[]

export const useFetchManlaboSurveySelectedQuestionsByRestaurantId = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `manzokudo_labo/restaurants/${restaurantId}/survey/questions/selected/` : null;
  const { data: selectedQuestions, error, isLoading } = useSWR<SelectedQuestions>(fetcherKey)
  return { selectedQuestions, isLoading, error };
};